/* eslint-disable max-len */
import * as visuals from 'src/helpers/visuals';

export type DrawingId = typeof drawings[number]['id'];

export const drawings = <const>[
  {
    id: 'main',
    image: visuals.mainVisual,
    title: 'Schip',
    description: null,
    hfov: 130, // Will not be used since this image isn't a Pannellum instance but a SVG
    svgPath: null,
  },
  {
    id: 'brug',
    image: visuals.brug,
    title: 'Brug: onderwijskundig leiderschap',
    description: 'Blijven we op koers of moeten we bijsturen? Wat komen we onderweg tegen en hoe houden we daar rekening mee? Hoe vinden we betere routes naar nieuwe bestemmingen? We nemen regie en verantwoordelijkheid voor onze reis. Ieder binnen zijn eigen taak, rol of bevoegdheid. Zo besturen wij ons schip!',
    hfov: 130,
    svgPath: { cx: 822.3, cy: 564 },
  },
  {
    id: 'kraancabine',
    image: visuals.kraancabine,
    title: 'Kraancabine: thematisch onderwijs',
    description: 'We bieden ons onderwijs en examinering integraal aan en doen dit in korte en overzichtelijke periodes. Zo werken we van vakantie tot vakantie. Wel zo overzichtelijk!',
    hfov: 130,
    svgPath: { cx: 1319.7, cy: 502.4 },
  },
  {
    id: 'lounge',
    image: visuals.lounge,
    title: 'Lounge: ontmoeting en verbinding',
    description: 'We beseffen ons heel goed dat wij een maatschappelijke opdracht in een onderwijskundig jasje hebben. We zijn ons bewust van de steeds veranderende maatschappelijke context en weten wanneer we hierop moeten anticiperen. Bij ons op school is het veilig en vertrouwd en kun je altijd terecht. Onze studenten kijken terug op een fijne tijd bij ons! ',
    hfov: 130,
    svgPath: { cx: 699.2, cy: 690.2 },
  },
  {
    id: 'ingang',
    image: visuals.ingang,
    title: 'Ingang: iedereen is welkom!',
    description: 'Elke student die ouder is dan 16 en niet in staat is geweest een vo-diploma te behalen is welkom bij ons. We zijn er overigens ook voor volwassenen, want wij willen dat er geen \'Rotterdammert aan de kant\' blijft staan. Hoe spelen wij eigenlijk in op al die verschillende doelgroepen en leerbehoeften?',
    hfov: 130,
    svgPath: { cx: 1319.7, cy: 916.2 },
  },
  {
    id: 'machinekamer',
    image: visuals.machinekamer,
    title: 'Machinekamer: professionele basis',
    description: 'We vertrouwen op een aantal methodieken en concepten die hun meerwaarde hebben bewezen en ons houvast bieden. Dit is ons fundament, onze basis: de olie waar onze motor altijd op draait.',
    hfov: 130,
    svgPath: { cx: 809.4, cy: 1040.9 },
  },
  {
    id: 'de-uitkijk',
    image: visuals.deUitkijk,
    title: 'Uitkijk: positionering naar buiten',
    description: 'De wereld om ons heen verandert continu. Daar moeten we alert op blijven! Wat zien we eigenlijk als we om ons heen kijken? ',
    hfov: 130,
    svgPath: { cx: 1734.3, cy: 681.7 },
  },
  {
    id: 'boeg',
    image: visuals.boeg,
    title: 'Boeg: onze missie!',
    description: 'Wij willen bijdragen aan het geluk van onze studenten, door ze de grootste kans op succes te bieden bij hun volgende stap naar een baan of vervolgopleiding. Hoe dat er voor onze studenten uitziet?',
    hfov: 130,
    svgPath: { cx: 2221.9, cy: 781.3 },
  },
];
